module.exports = __webpack_public_path__ + "static/media/about-certificate-img7.5feaecd4.jpg";